import React from "react"
import { useTranslation } from "react-i18next"

import { useApiContext } from "~/api"
import { EventCard } from "~/components/EventCard/EventCard"
import { Heading } from "~/components/Heading/Heading"
import { Link } from "~/components/Link/Link"
import { Raw } from "~/components/raw"

import styles from "./index.module.css"

export const Calendar: React.FC = () => {
  const { t } = useTranslation()
  const { items: events } = useApiContext("/calendar/list")
  if (!events || events.length === 0) {
    return null
  }

  const investorsEvents = events.filter(
    ({ showOnInvestors, status }) => showOnInvestors && status === "active",
  )

  return (
    <div className={styles.Wrapper}>
      <div className="container">
        <div>
          <Heading as="h2" className={styles.Title} like="h1">
            <Raw html={t("investors-and-shareholders.Calendar.Title")} />
          </Heading>
          <Link href="/investors-and-shareholders/calendar" view="arrow">
            <Raw html={t("investors-and-shareholders.Calendar.Link")} />
          </Link>
        </div>

        {investorsEvents && investorsEvents.length !== 0 && (
          <div className={styles.Events}>
            {investorsEvents.slice(0, 2).map((event, i) => (
              <EventCard {...event} key={i} />
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
